import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import styles from './Menu.module.less';
import useLog from '../../hooks/useLog';
import { scrollClear } from '../../../../actions/game';

export default memo(({ base, tabs }) => {
  const dispatch = useDispatch();
  const [, track] = useLog();

  const _track = source => {
    track(1, source);
    dispatch(scrollClear());
  };

  return (
    <div className={styles.Menu}>
      <div>
        <nav>
          {tabs.map(tab => (
            <NavLink
              key={tab.code}
              to={`${base}/${tab.code}`}
              onClick={() => _track(tab.source)}>
              {
                tab.noSelectIcon
                ?
                <React.Fragment>
                  <img src={tab.noSelectIcon} alt="" />
                  <img src={tab.selectIcon || tab.noSelectIcon} alt="" />
                </React.Fragment>
                :
                null
              }
              {tab.name}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
});
